import {FC} from 'react'
import {QRCodeSVG} from 'qrcode.react'
import {useTranslation} from '@/translations/i18n.tsx'
import {ButtonLink} from '@components/commons/button-link'
import {routes} from '@utilities/constants/routes.tsx'
import {FLOOR_PLAN_APP_TESTFLIGHT_URL} from '@features/floor-plan/constants.ts'
import {FloorPlanCaptureSteps} from '@features/floor-plan/components/floor-plan-capture-steps'
import {FloorPlanOptInOrigin} from '@features/floor-plan/components/floor-plan-optin-button'

/**
 * Success / already-opted-in state of the opt-in page. Two equal columns on
 * desktop — the "get the app" steps and back / download actions on the left, QR
 * on the right. On mobile it collapses to a single column with the QR sitting
 * directly under the subtitle.
 */
export const FloorPlanCompletedStep: FC<{from?: FloorPlanOptInOrigin}> = ({from}) => {
    const {t} = useTranslation()

    const backTo = from === 'settings' ? routes.SETTINGS.handle.fullPath : routes.HOME.handle.fullPath
    const backLabel = from === 'settings' ? t('floor_plan:opt_in:back_settings') : t('floor_plan:opt_in:back_home')

    return (
        <div className="grid w-full items-start gap-x-10 gap-y-6 grid-cols-1 [grid-template-areas:'subtitle'_'qr'_'steps'_'actions'] md:grid-cols-2 md:[grid-template-areas:'subtitle_qr'_'steps_qr'_'actions_qr']">
            <FloorPlanCaptureSteps
                qr={
                    <div className="[grid-area:qr] self-start p-3 border border-neutral-200 rounded-lg leading-none justify-self-start md:justify-self-center">
                        <QRCodeSVG
                            size={200}
                            value={FLOOR_PLAN_APP_TESTFLIGHT_URL}
                            title={t('floor_plan:capture_modal:qr_title')}
                        />
                    </div>
                }
            />
            <div className="[grid-area:actions] flex flex-wrap items-center justify-start gap-4">
                <ButtonLink to={backTo} variant="secondary">
                    {backLabel}
                </ButtonLink>
                <ButtonLink
                    to={FLOOR_PLAN_APP_TESTFLIGHT_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="primary"
                >
                    {t('floor_plan:capture_modal:download_app')}
                </ButtonLink>
            </div>
        </div>
    )
}
